import { render, staticRenderFns } from "./Ugcs.vue?vue&type=template&id=e91c3c0e&"
import script from "./Ugcs.vue?vue&type=script&lang=ts&"
export * from "./Ugcs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports